export default "__VITE_ASSET__DE3$a_LD__"